let version = require("../../../package.json").version;
export const API_URL =
  process.env.REACT_APP_API_URL || "https://qa-push-api.esoko.com/api/v1" || "http://localhost:3000/api/v1";
//"http://192.168.3.65:8082/v1";
// 'http://push-api.qa.esoko.com/v1' ||
//"https://6ba0-196-61-35-194.ngrok.io/v1";
// ("http://push-api.qa2.esoko.com:8082/v1");

export const SSO_URL =
  process.env.REACT_APP_SSO_URL ||
  // 'http://192.168.3.82:1911/v1' ||
  "http://push-sso-api.qa.esoko.com:8080/v1";
// 'http://push-sso-api.qa.esoko.com:8080/v1'

export const SSO_API =
  process.env.REACT_APP_SSO_API_URL ||
  "https://qa-sso-api.esoko.com/api/v2" ||
  "http://accounts-sso.qa.esoko.com:5050/api/v2";

export const REACT_APP_VERSION = version;
export const REACT_APP_COOKIES_DOMAIN =
  process.env.REACT_APP_COOKIES_DOMAIN || window.location.hostname;
export const REACT_APP_NODE_ENV =
  process.env.REACT_APP_NODE_ENV || "development";
export const REACT_INTERCOM_APP_ID =
  process.env.REACT_INTERCOM_APP_ID || "jxm2i8o8";
export const REACT_RECAPTCHA_SECRET_KEY =
  process.env.REACT_RECAPTCHA_SECRET_KEY ||
  "6Le2HWIUAAAAACcBS0_vW-Dxvo7yZ9pbT_tVi9FC";
export const REACT_GOOGLE_MAP_API =
  process.env.REACT_GOOGLE_MAP_API || "AIzaSyCSjXAyUEZPiaycd0AkSlYoW2byopYtdVQ";
export const REACT_RECAPTCHA_SITE_KEY =
  process.env.REACT_RECAPTCHA_SITE_KEY ||
  "6Le2HWIUAAAAAA77C0BjqJSkbarZPuT9Gfc_GGBi";
export const STORAGE_PRFX = process.env.REACT_APP_STORAGE_PREFIX || "esk_";
export const WEATHER_RECIPIENT_LIMIT =
  parseInt(process.env.REACT_APP_WEATHER_RECIPIENT_LIMIT) || 10000;
export const REACT_APP_VOICE_ACCESS =
  process.env.REACT_APP_VOICE_ACCESS ||
  "ghana,699d8f4f-68f6-4eb2-a495-57053e3f4f0f,41b27f93-3beb-4d87-9098-0b95c693d6c4";
export const REACT_APP_ACCOUNT_APP_URL =
  process.env.REACT_APP_ACCOUNT_APP_URL || "http://localhost:4000";

export const MESSAGING_API_URL =
  process.env.REACT_APP_MESSAGING_API_URL || "https://qa-messaging-api.esoko.com" || "http://localhost:3000";

export const PEOPLE_API_URL =
  process.env.REACT_APP_PEOPLE_API_URL || "https://qa-people-api.esoko.com/v1";

export const CONTENT_API_URL =
  process.env.REACT_APP_CONTENT_API_URL || "https://qa-content-api.esoko.com/api/v1";

export const MESSAGING_API_CLIENT_KEY =
  process.env.REACT_APP_MESSAGING_API_CLIENT_KEY || "3754996cad";

export const MESSAGING_API_CLIENT_SECRET =
  process.env.REACT_APP_MESSAGING_API_CLIENT_SECRET ||
  "4UyTVAS&hipq8f6ZgqVQPptHR";
